import { atom } from 'recoil';

export const preparedBudgetIdAtom = atom<number | null>({
  key: 'preparedBudgetIdAtom',
  default: null,
});
